import React from 'react';
import './UserCard.css';

const UserCard = ({ user, onPartnerLogout }) => {
  if (!user) return null;

  return (
    <div className="user-card">
      <img src={user.logo} alt="User Logo" className="user-logo" />

      <div className="user-info">
        <p className="user-name">{user.name}</p>
        <p className="user-phone">{user.phone}</p>
      </div>

      {onPartnerLogout && (
        <button
          className="partner-logout-btn"
          onClick={onPartnerLogout}
          title="Logout partner"
        >
          ⏻
        </button>
      )}
    </div>
  );
};

export default UserCard;